/**
 * MY CLASSROOMS index (A4): the student's door to their cohorts. The teacher
 * tier enters via `/academy/cohorts`; this one is the student body's.
 */
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { MyClassroomsView } from "@/features/academy/components/classroom/my-classrooms-view";

export const classroomIndexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/classroom",
  component: MyClassroomsView,
});
